export const CATEGORY_NAME = "categoryName";
export const PROPERTY_CATEGORY = "propertyCategoryIds";
export const DESCRIPTION = "description";
